var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Gardeners',"subtitle":'Edit Profile'}}),_c('gardener-form',{attrs:{"action":"edit","gardener":_vm.gardener,"loading":_vm.loading},on:{"update:loading":function($event){_vm.loading=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }